import axios from 'axios'
import { API_URL } from '../../../../modules/auth/core/_requests'


export async function assignLocation(lineItemId: number, location: string): Promise<{ success: boolean, status: string }> {
  try {
    const response = await axios.put(`${API_URL}/api/shopify-shipping/dashboard/assignments/assign-location/${lineItemId}`, {
      fulfillment_location: location
    })
    return { success: response.data.success || 'success', status: response.data.status || 'assigned' }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        throw new Error(error.response.data?.error || 'Failed to assign location')
      } else {
        throw new Error('Network error when assigning location')
      }
    }
    throw error
  }
}


export async function reassignLocation(lineItemId: number, location: string): Promise<{ success: boolean, status: string }> {
  try {
    const response = await axios.put(`${API_URL}/api/shopify-shipping/dashboard/assignments/reassign-location/${lineItemId}`, {
      fulfillment_location: location
    })
    return { success: response.data.success || 'success', status: response.data.status || 'assigned' }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        throw new Error(error.response.data?.error || 'Failed to assign location')
      } else {
        throw new Error('Network error when assigning location')
      }
    }
    throw error
  }
}

// Type definition for assignment objects
interface Assignment {
  line_item_id: string;
  store_name: string;
}

export const bulkAssign = async (orderId: string, assignments: Assignment[]) => {
  const response = await fetch(`${API_URL}/api/shopify-shipping/dashboard/line-items-bulk-assignments/execute`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      order_id: orderId,
      assignments: assignments
    })
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }

  return await response.json();
};